import type { CSSProperties } from 'react';
import styles from './OptionSwatch.module.scss';

const toHex = (hexColor: string) =>
  hexColor.startsWith('#') ? hexColor : `#${hexColor}`;

const SwatchFace: React.FC<{
  selected?: boolean;
  style: CSSProperties;
}> = ({ selected = false, style }) => (
  <span
    aria-hidden="true"
    className={[styles.swatch, selected ? styles.selected : '']
      .filter(Boolean)
      .join(' ')}
    style={style}
  />
);

export const SingleColorSwatch: React.FC<{
  hexColor: string;
  imageUrl?: string;
  selected?: boolean;
}> = ({ hexColor, imageUrl, selected }) => (
  <SwatchFace
    selected={selected}
    style={{
      backgroundColor: toHex(hexColor),
      ...(imageUrl ? { backgroundImage: `url(${imageUrl})` } : {}),
    }}
  />
);

export const ColorWithBackingSwatch: React.FC<{
  productHexColor?: string;
  backingHexColor?: string;
  selected?: boolean;
}> = ({ productHexColor = '', backingHexColor = '', selected }) => (
  <SwatchFace
    selected={selected}
    style={{
      background: `linear-gradient(45deg, ${toHex(productHexColor)} 50%, ${toHex(
        backingHexColor
      )} 50%)`,
    }}
  />
);

export const BodySleeveSwatch: React.FC<{
  bodyHexColor?: string;
  sleeveHexColor?: string;
  selected?: boolean;
}> = ({ bodyHexColor = '', sleeveHexColor = '', selected }) => (
  <SwatchFace
    selected={selected}
    style={{
      background: `linear-gradient(45deg, ${toHex(
        sleeveHexColor
      )} 50%, ${toHex(bodyHexColor)} 50%)`,
    }}
  />
);
